import { Button, Grid, TextField } from "@mui/material";
import { downloadWorklist } from "features/WorklistTools/shared/WorklistHelpers";
import { FormikErrors } from "formik";
import {
  MethodReservation,
  OperationNames,
  useDeleteExistingMethodReservationMutation,
} from "graphql/generated/schema-types";
import styled from "styled-components";
import { GeneralFeedData } from "./constants";

export interface GeneralFeedProps {
  methodReserved: boolean;
  methodReservation: MethodReservation[];
  values: GeneralFeedData;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined,
  ) => Promise<void> | Promise<FormikErrors<GeneralFeedData>>;
  errors: FormikErrors<GeneralFeedData>;
  isValid: boolean;
  isSubmitting: boolean;
  loading: boolean;
}

const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  height: 70px;
  justify-content: space-evenly;
  align-items: center;
`;

export const GeneralFeedFooter = ({
  methodReserved,
  methodReservation,
  values,
  setFieldValue,
  errors,
  isValid,
  isSubmitting,
  loading,
}: GeneralFeedProps) => {
  const [deleteReservation] = useDeleteExistingMethodReservationMutation({
    awaitRefetchQueries: true,
  });
  const deleteMethodReservation = () => {
    if (methodReserved) {
      deleteReservation({
        variables: {
          methodReservationId: methodReservation[0]?.methodReservationId ?? 0,
        },
        refetchQueries: [
          OperationNames.Query.getMethodReservationByPersonalTaskId,
        ],
      });
    }
  };
  return (
    <ButtonContainer>
      {methodReserved ? (
        <>
          <Button variant="contained" onClick={deleteMethodReservation}>
            Delete Reservation
          </Button>
          <Button
            variant="contained"
            onClick={() =>
              downloadWorklist(methodReservation[0]?.methodReservationId ?? 0)
            }
          >
            Download Worklist
          </Button>
        </>
      ) : (
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={8}>
            <TextField
              label="File Name"
              fullWidth
              size="small"
              name="fileName"
              value={values.fileName}
              onChange={(e) => setFieldValue("fileName", e.target.value)}
              error={!!errors.fileName}
              helperText={errors.fileName}
            />
          </Grid>

          <Grid item xs={4}>
            <Button
              variant="contained"
              type="submit"
              disabled={!isValid || isSubmitting || loading}
            >
              Generate Worklist
            </Button>
          </Grid>
        </Grid>
      )}
    </ButtonContainer>
  );
};
